import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ISettingAffiliateBannerResponse } from '@modules/general-settings/submodules/affiliate-banner/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  ADMIN_GENERAL_SETTINGS_AFFILIATE_BANNER_PERMISSIONS,
  SETTINGS_AFFILIATE_BANNER_QUERY_KEY,
  SETTINGS_AFFILIATE_BANNER_URL,
} from '@modules/general-settings/submodules/affiliate-banner/constants';

export default function useSettingsAffiliateBannerQuery(): IContextQueryResult<ISettingAffiliateBannerResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ISettingAffiliateBannerResponse, Error>({
    queryKey: [SETTINGS_AFFILIATE_BANNER_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet(SETTINGS_AFFILIATE_BANNER_URL, {
      signal,
      permission: ADMIN_GENERAL_SETTINGS_AFFILIATE_BANNER_PERMISSIONS.BANNERSETTINGS_SHOW,
    }),
  });
}
